import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Row, Col, Form, InputNumber, Button, Table } from 'antd';

@inject('store')
@observer
export class CalculatorView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountBalance: 100,
            entryPrice: 10000,
            layers: []
        };
    }
    render() {
        const { exchangePosition, ticker, config } = this.props.store.makoBotStore;

        if (!exchangePosition || !ticker || !config) return <div>Loading...</div>;

        return (
            <Row gutter={16}>
                <Col xs={24} md={3}>
                    <Card
                        title="Setup"
                        bordered={false}
                        size="small"
                        style={{ marginBottom: 10 }}
                        headStyle={{ backgroundColor: '#1c1e2f' }}
                        bodyStyle={{
                            backgroundColor: '#1c1e2f',
                            borderBottomLeftRadius: 6,
                            borderBottomRightRadius: 6
                        }}
                    >
                        <Row gutter={16}>
                            <Col xs={24}>
                                <Form.Item
                                    label={'Account Balance'}
                                    extra={
                                        <Button
                                            block
                                            ghost
                                            type="primary"
                                            onClick={() =>
                                                this.setState({
                                                    accountBalance: exchangePosition.wallet_balance
                                                })
                                            }
                                        >
                                            {exchangePosition.wallet_balance}{' '}
                                            {exchangePosition.symbol.replace('USD', '')}
                                        </Button>
                                    }
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        value={this.state.accountBalance}
                                        onChange={accountBalance =>
                                            this.setState({ accountBalance })
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item
                                    label={'Entry Price'}
                                    extra={
                                        <Button
                                            block
                                            ghost
                                            type="primary"
                                            onClick={() =>
                                                this.setState({
                                                    entryPrice: ticker.last
                                                })
                                            }
                                        >
                                            Current Price: {ticker.last}
                                        </Button>
                                    }
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        value={this.state.entryPrice}
                                        onChange={entryPrice => this.setState({ entryPrice })}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col xs={24} md={21}>
                    <Card
                        title="Layer Details"
                        bordered={false}
                        size="small"
                        style={{ marginBottom: 10 }}
                        headStyle={{ backgroundColor: '#1c1e2f' }}
                        bodyStyle={{
                            backgroundColor: '#1c1e2f',
                            borderBottomLeftRadius: 6,
                            borderBottomRightRadius: 6
                        }}
                        extra={
                            <div>
                                <Button
                                    type="primary"
                                    onClick={value => {
                                        console.log(config);
                                        let next = config.long.layers
                                            .filter(l => l.enabled)
                                            .map((l, i) => {
                                                return { id: i, ...l };
                                            });

                                        this.setState({ layers: next });
                                    }}
                                >
                                    Load Long Config
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                    type="primary"
                                    onClick={value => {
                                        let next = config.short.layers.map((l, i) => {
                                            return { id: i, ...l };
                                        });

                                        this.setState({ layers: next });
                                    }}
                                >
                                    Load Short Config
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                    shape="circle"
                                    icon="plus-circle"
                                    type="primary"
                                    onClick={value => {
                                        let next = [...this.state.layers];
                                        next.push({ id: Date.now(), qty: 0, spread: 0, tp: 0 });
                                        this.setState({ layers: next });
                                    }}
                                />
                            </div>
                        }
                    >
                        <Table
                            pagination={false}
                            rowKey={'id'}
                            columns={[
                                {
                                    title: '',
                                    dataIndex: 'action',
                                    key: 'action',
                                    render: (text, o) => {
                                        return (
                                            <Button
                                                shape="circle"
                                                icon="delete"
                                                type="danger"
                                                onClick={value => {
                                                    let next = this.state.layers.filter(
                                                        l => l.id !== o.id
                                                    );

                                                    this.setState({ layers: next });
                                                }}
                                            />
                                        );
                                    }
                                },

                                {
                                    title: 'Qty',
                                    dataIndex: 'qty',
                                    key: 'qty',
                                    render: (text, o) => {
                                        return (
                                            <InputNumber
                                                onChange={value => {
                                                    let next = [...this.state.layers];
                                                    let layer = next.find(l => l.id === o.id);
                                                    layer.qty = value;
                                                    this.setState({ layers: next });
                                                }}
                                                value={o.qty}
                                            />
                                        );
                                    }
                                },
                                {
                                    title: 'Spread %',
                                    dataIndex: 'spread',
                                    key: 'spread',
                                    render: (text, o) => {
                                        return (
                                            <InputNumber
                                                onChange={value => {
                                                    let next = [...this.state.layers];
                                                    let layer = next.find(l => l.id === o.id);
                                                    layer.spread = value;
                                                    this.setState({ layers: next });
                                                }}
                                                value={o.spread}
                                            />
                                        );
                                    }
                                },
                                {
                                    title: 'Take Profit %',
                                    dataIndex: 'tp',
                                    key: 'tp',
                                    render: (text, o) => {
                                        return (
                                            <InputNumber
                                                onChange={value => {
                                                    let next = [...this.state.layers];
                                                    let layer = next.find(l => l.id === o.id);
                                                    layer.tp = value;
                                                    this.setState({ layers: next });
                                                }}
                                                value={o.tp}
                                            />
                                        );
                                    }
                                },
                                {
                                    title: 'Held',
                                    dataIndex: 'held',
                                    key: 'held',
                                    render: (t, o) => {
                                        const pastLayers = this.state.layers.filter(
                                            l => l.id <= o.id
                                        );
                                        return pastLayers.reduce((acc, o) => acc + o.qty, 0);
                                    }
                                },
                                {
                                    title: 'Entry Price',
                                    dataIndex: 'entry_price',
                                    key: 'entry_price',
                                    render: (t, o) => {
                                        return (
                                            this.state.entryPrice -
                                            this.state.entryPrice * (o.spread / 100)
                                        ).toFixed(4);
                                    }
                                },
                                {
                                    title: 'Avg Entry Price',
                                    dataIndex: 'avg_entry_price',
                                    key: 'avg_entry_price',
                                    render: (t, o) => {
                                        const pastLayers = this.state.layers.filter(
                                            l => l.id <= o.id
                                        );
                                        const totalHeld = pastLayers.reduce(
                                            (acc, o) => acc + o.qty,
                                            0
                                        );

                                        const heldValue = pastLayers.reduce((acc, o) => {
                                            const entryPrice =
                                                this.state.entryPrice -
                                                this.state.entryPrice * (o.spread / 100);

                                            return acc + o.qty / entryPrice;
                                        }, 0);
                                        return (totalHeld / heldValue).toFixed(8);
                                    }
                                },
                                {
                                    title: 'Layer Value',
                                    dataIndex: 'layer_value',
                                    key: 'layer_value',
                                    render: (t, o) => {
                                        const entryPrice =
                                            this.state.entryPrice -
                                            this.state.entryPrice * (o.spread / 100);

                                        return (o.qty / entryPrice).toFixed(8);
                                    }
                                },
                                {
                                    title: 'Held Value',
                                    dataIndex: 'held_value',
                                    key: 'held_value',
                                    render: (t, o) => {
                                        const pastLayers = this.state.layers.filter(
                                            l => l.id <= o.id
                                        );

                                        const totalHeld = pastLayers.reduce(
                                            (acc, o) => acc + o.qty,
                                            0
                                        );
                                        const heldValue = pastLayers.reduce((acc, o) => {
                                            const entryPrice =
                                                this.state.entryPrice -
                                                this.state.entryPrice * (o.spread / 100);

                                            return acc + o.qty / entryPrice;
                                        }, 0);
                                        const avgEntry = totalHeld / heldValue;

                                        return (totalHeld / avgEntry).toFixed(8);
                                    }
                                },
                                {
                                    title: 'Liquidation Price',
                                    dataIndex: 'liq_price',
                                    key: 'liq_price',
                                    render: (t, o) => {
                                        const fee = 1.00075;
                                        const pastLayers = this.state.layers.filter(
                                            l => l.id <= o.id
                                        );

                                        const totalHeld = pastLayers.reduce(
                                            (acc, o) => acc + o.qty,
                                            0
                                        );
                                        const heldValue = pastLayers.reduce((acc, o) => {
                                            const entryPrice =
                                                this.state.entryPrice -
                                                this.state.entryPrice * (o.spread / 100);

                                            return acc + o.qty / entryPrice;
                                        }, 0);
                                        const avgEntry = totalHeld / heldValue;
                                        return (
                                            <span style={{ color: '#f4b344' }}>
                                                {(
                                                    (fee * totalHeld) /
                                                    (totalHeld / avgEntry +
                                                        (this.state.accountBalance + 0))
                                                ).toFixed(8)}
                                            </span>
                                        );
                                    }
                                },
                                {
                                    title: 'Fee',
                                    dataIndex: 'fee',
                                    key: 'fee',
                                    render: (t, o) => {
                                        const pastLayers = this.state.layers.filter(
                                            l => l.id <= o.id
                                        );

                                        const fee = pastLayers.reduce((acc, o) => {
                                            const entryPrice =
                                                this.state.entryPrice -
                                                this.state.entryPrice * (o.spread / 100);

                                            return acc + (o.qty / entryPrice) * -0.00025;
                                        }, 0);

                                        return (
                                            <span style={{ color: '#29c0b1' }}>
                                                {fee.toFixed(8)}
                                            </span>
                                        );
                                    }
                                },
                                {
                                    title: 'Trade Profit',
                                    dataIndex: 'profit',
                                    key: 'profit',
                                    render: (t, o) => {
                                        const pastLayers = this.state.layers.filter(
                                            l => l.id <= o.id
                                        );

                                        const totalHeld = pastLayers.reduce(
                                            (acc, o) => acc + o.qty,
                                            0
                                        );
                                        const heldValue = pastLayers.reduce((acc, o) => {
                                            const entryPrice =
                                                this.state.entryPrice -
                                                this.state.entryPrice * (o.spread / 100);

                                            return acc + o.qty / entryPrice;
                                        }, 0);

                                        const avgEntry = totalHeld / heldValue;
                                        const profit =
                                            heldValue -
                                            totalHeld / (avgEntry + avgEntry * (o.tp / 100));
                                        return (
                                            <span style={{ color: '#29c0b1' }}>
                                                {profit.toFixed(8)}
                                            </span>
                                        );
                                    }
                                },
                                {
                                    title: 'Profit %',
                                    dataIndex: 'profit_pc',
                                    key: 'profit_pc',
                                    render: (t, o) => {
                                        const pastLayers = this.state.layers.filter(
                                            l => l.id <= o.id
                                        );

                                        const totalHeld = pastLayers.reduce(
                                            (acc, o) => acc + o.qty,
                                            0
                                        );
                                        const heldValue = pastLayers.reduce((acc, o) => {
                                            const entryPrice =
                                                this.state.entryPrice -
                                                this.state.entryPrice * (o.spread / 100);

                                            return acc + o.qty / entryPrice;
                                        }, 0);

                                        const fee = pastLayers.reduce((acc, o) => {
                                            const entryPrice =
                                                this.state.entryPrice -
                                                this.state.entryPrice * (o.spread / 100);

                                            return acc + (o.qty / entryPrice) * -0.00025;
                                        }, 0);

                                        const avgEntry = totalHeld / heldValue;

                                        const margin = heldValue / 100;
                                        const profit =
                                            heldValue -
                                            totalHeld / (avgEntry + avgEntry * (o.tp / 100)) -
                                            fee;

                                        const totalProfit = margin + profit;
                                        const profitPct = ((totalProfit - margin) / margin) * 100;
                                        return (
                                            <span style={{ color: '#29c0b1' }}>
                                                {profitPct.toFixed(2)}%
                                            </span>
                                        );
                                    }
                                }
                            ]}
                            dataSource={this.state.layers}
                        />
                    </Card>
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/CalculatorTab/index.js